import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Add_ticket from './../../assets/images/add.png';
import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import $ from 'jquery';
import Header from './../../Header';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Add_request from './../../assets/images/add.png';
class SlaList extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = this.decrypt(localStorage.getItem('encdata'), 0);
        this.onChange = this.onChange.bind(this);
        this.searchChange = this.searchChange.bind(this);
        this.priortyChange = this.priortyChange.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.sortByChange = this.sortByChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.state = {
            slas: [],
            plan: [],
            description: '',
            status: [],
            priority_type: [],
            sortBy: '',
            search: '',
            config: '',
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            activePage: 1,
            item_count: '',
            loading: 1,
            isLoadMore: 1,
            orderBy: 'desc',
            order_col: 'sla_id',
        };
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    handleSort(columnSort) {
        var columnName = 'sla_' + columnSort;
        var orderBy, arrow;
        if (this.state.orderBy == 'desc') {
            orderBy = 'asc';
            arrow = '<i class= "fas fa-arrow-down leftmargin"></i>';
        }
        else {
            orderBy = 'desc';
            arrow = '<i class= "fas fa-arrow-up leftmargin"></i>';
        }
        var prev_col = this.state.order_col;
        var prev_dynamic_id = 'sla_' + prev_col;
        if (document.getElementById(prev_dynamic_id))
            document.getElementById(prev_dynamic_id).innerHTML = document.getElementById(prev_dynamic_id).textContent;
        localStorage.setItem('orderBy', orderBy);
        localStorage.setItem('order_col', columnSort);
        this.setState({ orderBy: orderBy, order_col: columnSort }, function () {
            var a = document.getElementById(columnName).textContent;
            var b = a + arrow;
            document.getElementById(columnName).innerHTML = b;
            this.SlaList();
        });

    }
    back() {
        window.location.href = '/SlaList';
    }
    searchChange(event) {
        var obj = this;
        this.setState({ search: event.target.value, activePage: 1 });
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            localStorage.setItem('search', document.getElementById('search').value);
            obj.SlaList();
        }, 500);
    }
    priortyChange(event) {
        this.setState({ priority_name: event.target.value },
            function () {
                this.SlaList();
            });
    }
    statusChange(event) {
        this.setState({
            status_name: event.target.value,
        }, function () {
            this.SlaList();
        });
    }
    sortByChange(event) {
        this.setState({ sortBy: event.target.value }, function () {
            this.SlaList();
        });
    }
    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/SlaRest/getSlaList/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        slas: findresponse.slas,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }
    SlaList(page = 1) {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.list_check').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/SlaRest/getSlaList/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                    $('.list_check').removeClass('hidden');
                });
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    loading: 0,
                    slas: findresponse.slas,
                    item_count: findresponse.item_count,
                    config: findresponse.config,
                    userid: findresponse.userid,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }
    getSlaRows() {
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div>
                    <div class="loader-new"></div>
                    <div class="list_check hidden">
                        <div class="tickets hidden-sm">
                            <ul class="tickets_head er_head">
                                <li class="intra_col_10" id="sla_plan" onClick={this.handleSort.bind(this, 'plan')}>Plan</li>
                                <li class="intra_col_10" id="sla_priority_type" onClick={this.handleSort.bind(this, 'priority_type')}>Priority</li>
                                <li class="intra_col_10" id="initial_nearing_responce_time">Initial Nearing</li>
                                <li class="intra_col_10" id="initial_missed_responce_time">Initial Missed</li>
                                <li class="intra_col_11" id="updated_nearing_responce_time">Update Nearing</li>
                                <li class="intra_col_11" id="updated_missed_responce_time">Update Missed</li>
                                <li class="intra_col_26" id="sla_description">Description</li>
                                <li class="intra_col_8" id="sla_status" onClick={this.handleSort.bind(this, 'status')}>Status</li>
                                <li class="intra_col_4 text-center">Action</li>

                            </ul>
                            {
                                this.state.slas.map((sla, key) =>
                                    <ul class="tickets_number">
                                        <li class="intra_col_10 text-inded">{sla.plan}</li>
                                        <li class="intra_col_10"> {sla.priority_type} </li>
                                        <li class="intra_col_10">{sla.initial_nearing_responce}</li>
                                        <li class="intra_col_10"> {sla.initial_missed_responce}</li>
                                        <li class="intra_col_11">{sla.update_nearing_responce}</li>
                                        <li class="intra_col_11"> {sla.update_missed_responce}</li>
                                        <li class="intra_col_26 text-inded" dangerouslySetInnerHTML={{ __html: sla.description }}></li>
                                        <li class="intra_col_8">{sla.status == 1 ? 'Active' : 'Inactive'}</li>
                                        <li class="intra_col_4 text-center"><span><a href={`/EditSla/${sla.sla_id}`}><i class="far fa-edit"></i></a></span></li>
                                    </ul>
                                )
                            }
                        </div>
                        <div class="tickets_mob er_list hidden-md">
                            <a name="max" href="/viewEr/23507">
                                <div class="list_mob"><span><h4 class="list_title"><div class="er_color"><span class="er_sym assigned"></span>
                                    <div class="text-inded">xyz test</div>
                                </div>
                                </h4>
                                    <div class="section">
                                        <div class="wrap pull-left">
                                            <label>#Ticket:</label><span>23507</span>
                                        </div>
                                        <div class="wrap pull-right">
                                            <label>Priority</label>
                                            <div class="text-capitalize">Medium</div>
                                        </div>
                                    </div>
                                    <div class="section gry">
                                        <div class="wrap">
                                            <label>POD</label><span>IOS</span>
                                        </div>
                                        <div class="wrap pull-right">
                                            <label>Assign to</label><span>Prashant Soy</span>
                                        </div>
                                    </div>
                                </span>
                                </div>
                            </a>
                        </div>
                        {this.state.item_count > 0 ? <div class="pagination-muvi">
                            <Pagination
                                itemClass={'pages'}
                                itemClassFirst={'first_page'}
                                itemClassPrev={'prev_page'}
                                itemClassNext={'next_page'}
                                itemClassLast={'last_page'}
                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={this.state.item_count}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                            />
                            <div style={{ color: "#333" }}>
                                {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                            </div>
                        </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                        {/* {this.loadMorecount()} */}
                    </div>
                </div>
            )
        }
    }
    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }
    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/SlaRest/getSlaList/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.slas.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    slas: this.state.slas.concat(findresponse.slas),
                })
            })
    }
    onChange(event) {
        this.setState({
            plan_type: event.target.value,
        }, function () {
            this.SlaList();
        });

    }
    GetSlaParameters() {
        fetch(this.state.apiUrl + '/SlaRest/GetSlaConfig/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    plan: findresponse.plan,
                    priority_type: findresponse.priority_type,
                    responceunits: findresponse.responceunits,
                    status: findresponse.status,
                })
            })
    }
    componentDidMount() {
        this.SlaList();
        this.GetSlaParameters();
        var obj = this;
        document.title = "Intranet | SLA List";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        $(document).ready(function () {
            setTimeout(function () {

            }, 10000);
            //Responsive filter
            $('.top-row .fa-sliders').on('click', function () {
                $(this).closest('.intranet_body').find('.form-section').slideToggle('slow');
            });
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="SLA Configuration" brecum_page="SLA Configuration" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                            <span>SLA Configuration</span>
                            <div class="mob-search hidden-md pull-right">
                                <i class="fa fa-search"></i>
                                <i class="fa fa-sliders" aria-hidden="true"></i>
                            </div>
                        </div>

                        <div class="top-row">
                            <div class="left-section btn-muvi pull-left">
                                <Link to="/addSla" class="btn btn-sky mob">
                                    <span class="hidden-sm">Add SLA</span>
                                    <span class="mob_icon_plus hidden-md">
                                        <img src={Add_request} />
                                    </span>
                                </Link>
                            </div>
                            <div class="right-section">
                                <div class="searchTicket emp_dept">
                                    <input type="text" class="form-control" name="search" id="search" placeholder="Search By Id or Keyword" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                </div>
                                <div class="searchTicket filter dept hidden-md"><i class="fa fa-sliders hidden-md filter"></i></div>
                            </div>
                        </div>
                        <div class="form-section mob_filter">
                            <div class="form-horizontal">
                                <div class="form-group col-sm-3 col-xs-12">
                                    <label>Plan Type</label>
                                    <div class="filter">
                                        <select class="form-control" name="plan" id="plan" onChange={this.onChange} >
                                            <option value='' selected >All</option>
                                            {
                                                this.state.plan.map((dynamicData, index) =>
                                                    <option value={dynamicData.value}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-12">
                                    <label>Priority</label>
                                    <div class="filter">
                                        <select class="form-control" name="priority_type" id="priority_type" onChange={this.priortyChange} >
                                            <option value='' selected >All</option>
                                            {
                                                this.state.priority_type.map((dynamicData, index) =>
                                                    <option value={dynamicData.value}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-12">
                                    <label>Status</label>
                                    <div class="filter">
                                        <select class="form-control" name="status" id="status" onChange={this.statusChange} >
                                            <option value='' selected >All</option>
                                            {
                                                this.state.status.map((dynamicData, index) =>
                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 filter_save mar_btm_16">
                                    <div class="btn-muvi todo-less">
                                        <button className="btn btn-blue" onClick={() => this.back()}>Reset</button>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        {this.getSlaRows()}
                    </div>
                </div>
            </div>
        );
    }
}
export default SlaList;


// WEBPACK FOOTER //
// ./src/components/sla/SlaList.js